import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loading: false,
  error: null,
  introStatus: false,
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    login: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    loginError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    loginReset: (state) => {
      state = initialState;
    },
    loginLoading: (state, action) => {
      state.loading = action.payload;
    },
    introStatusCheck: (state, action) => {
      state.introStatus = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { login, loginError, loginReset, loginLoading, introStatusCheck } =
  loginSlice.actions;

export default loginSlice.reducer;
